import Vue from "vue";
import App from "./App.vue";

import router from "@/router";

import Vue2TouchEvents from "vue2-touch-events";
Vue.use(Vue2TouchEvents, {
    swipeTolerance: 150
    // swipeTolerance: 50
});

Vue.config.productionTip = false;
Vue.config.devtools = true;

new Vue({
    router,
    render: h => h(App)
}).$mount("#app");
